<template>
  <v-container>
    <v-tabs v-model="tab">
      <v-tab>Users</v-tab>
      <v-tab>Company Group</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item class="pt-3">
        <members-setting-table />
      </v-tab-item>
      <v-tab-item class="pt-3">
        <group-company-settings-table />
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>
<script>
  import MembersSettingTable from '@/components/Dashboard/Views/Settings/components/MembersSettingTable.vue'
  import GroupCompanySettingsTable from '@/components/Dashboard/Views/Settings/components/GroupCompanySettingsTable.vue'

  export default {
    components: {
      MembersSettingTable,
      GroupCompanySettingsTable,
    },
    data: function () {
      return {
        tab: 1,
      }
    },
  }
</script>
<style scoped>
</style>
